import { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { useAuthStore, useAgentStore, useChatInputStore, useCoworkerStore, useModalStore, useModelStore } from '@/store';
import useRequireAuth from '@/hooks/useRequireAuth';

export default function useStartAgentChat() {
  const router = useRouter();
  const requireAuth = useRequireAuth();
  const isPlus = useAuthStore(state => state.user?.flags?.isPlus);
  const { openModal } = useModalStore(state => state.actions);

  return useCallback(agent => {
    if (!agent?.id) return;
    return requireAuth(() => {
      if (agent.flags?.isPlusOnly && !isPlus) {
        openModal('PricingModal', { title: 'Chat with this bot', subtitle: 'This bot requires a Plus subscription.' });
        return false;
      }
      const composer = useChatInputStore.getState();
      const arya = Object.values(useModelStore.getState().models || {}).find(model => model.slug === 'arya');
      useAgentStore.getState().addAgents([agent]);
      composer.setContext('new');
      composer.clearInput(true);
      composer.setSelectedModels(arya ? [arya.id] : []);
      composer.setSelectedAgents([agent.id], { botId: agent.id });
      useCoworkerStore.getState().setComposerMode('chat');
      router.push('/app');
      return true;
    }, {
      source: 'agent_card_quick_chat',
      title: `Sign in to chat with ${agent.name || 'this bot'}`,
      subtitle: 'Create a free account to save your conversations.',
      icon: 'robot',
    });
  }, [isPlus, openModal, requireAuth, router]);
}
